import React from 'react';
import { LinkIcon } from '@paypalcorp/pp-react';
import styles from './Anchor.module.less';
import classNames from 'classnames';
import hashNavigate from '../../util/hashNavigation';

interface AnchorProps {
  value: string;
  visible: boolean;
  onClick?: () => void;
  className?: string;
}

const Anchor = ({ value, visible, onClick = () => {}, className }: AnchorProps) => {
  const anchorClassName = classNames(className, { [styles.anchor_button]: !className });
  if (!visible) return null;
  const handleClick = (): void => {
    onClick();
    hashNavigate(value);
  };

  return (
    <button className={anchorClassName} onClick={handleClick}>
      <LinkIcon size="xs" />
    </button>
  );
};

export default Anchor;
